import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    routeMapLinkStyle: {
        width: '100%'
    },
    container: {
        minHeight: 445,
        minWidth: 360,
        [theme.breakpoints.down('xs')]: {
            minHeight: 380,
            minWidth: 280
        },
        height: '100%',
        cursor: 'pointer',
        borderRadius: '20px',
        backgroundColor: theme.palette.bg.white,
        border: `1px solid ${theme.palette.fg.silver}`,
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
            transition: 'all 0.3s ease',
            border: `1px solid ${theme.palette.fg.black}`
        }
    },
    schoolCardImage: {
        position: 'relative',
        width: '100%',
        height: '122px',
        [theme.breakpoints.up('sm')]: {
            height: '184px'
        }
    },
    paidIcon: {
        position: 'absolute',
        top: 8,
        right: 8,
        height: 42,
        width: 42,
        borderRadius: '100%',
        backgroundColor: 'var(--background-orange)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    cardMedia: {
        height: '100%',
        width: '100%',
        borderRadius: '20px 20px 0px 0px',
        objectFit: 'cover'
    },
    schoolLogo: {
        position: 'absolute',
        overflow: 'hidden',
        left: '20px',
        bottom: '0px',
        transform: 'translateY(50%)',
        width: '77px',
        height: '77px',
        border: `1px solid ${theme.palette.fg.silver}`,
        borderRadius: '50%',
        backgroundColor: theme.palette.bg.white,
        [theme.breakpoints.up('sm')]: {
            width: '70px',
            height: '70px'
        },
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    schoolInfoContainer: {
        width: '100%',
        flex: 1,
        padding: (props) => props.hasSchoolLogo ? '44px 23px 18px' : '23px 18px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        [theme.breakpoints.up('sm')]: {
            padding: (props) => props.hasSchoolLogo ? '44px 23px 18px' : '23px'
        }
    },
    textBox: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 24
    },
    schoolName: {
        overflow: 'hidden',
        lineHeight: 1.2,
        fontSize: 20,
        maxHeight: 'calc(22px * 1.2 * 2)', // title max 2 lines -> calc(fontSize * lineHeight * number of lines)
        wordBreak: 'word-break',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        marginBottom: '9px',
        color: theme.palette.fg.black
    },
    schoolDescription: {
        display: '-webkit-box',
        lineClamp: '3',
        boxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: theme.palette.fg.black,
        fontSize: 16,
        lineHeight: '22px'
    },
    learnMoreLink: {
        fontSize: 16,
        color: theme.palette.fg.purple
    },
    schoolDetails: {
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
        gap: 8
    }
}))
